<div class="row text-center">
  <div class="row">
    <h1>Your Quote</h1>
  </div>
  <div class="row risk">
    <div class="flex center pad-top-10">
      <div class="pad-right-10" aria-hidden="true">
        <span class="policyIcon icon-auto"></span>
      </div>
      <div class="risk-info">
        <div class="caption text-left" dsContent [contentPath]="'policy.newVehicleCaption'"></div>
        <div class="heading">
          {{ vehicleName }}
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="flex center quote-price">
      <div class="pad-right-10" aria-hidden="true">
        <span class="quote-large">${{ quoteData.quoteMonthlyDollars }}</span>
      </div>
      <div class="quote-small">
        <sub>.{{ quoteData.quoteMonthlyCents }}</sub>
        <div>/MO</div>
      </div>
    </div>
  </div>
  <div class="row pad-bottom-20">
    <div class="bold-header text-center">
      ${{ quoteData.quoteTotalAmount }} / {{ quoteData.quoteTerm }} mos
    </div>
  </div>
</div>
